import { useState, useCallback } from 'react';
import { supabase, isOnline } from '../lib/supabase';

export function useHousehold() {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const createHousehold = useCallback(async ({ householdName, memberName, memberType }) => {
    if (!isOnline()) return { error: { message: 'No connection to server' } };
    setLoading(true);
    setError(null);

    const { data, error: rpcError } = await supabase.rpc('create_household_with_member', {
      household_name: householdName,
      member_name: memberName,
      member_type: memberType,
    });

    setLoading(false);
    if (rpcError) {
      setError(rpcError.message);
      return { error: rpcError };
    }
    return { data };
  }, []);

  const joinHousehold = useCallback(async ({ code, memberName, memberType }) => {
    if (!isOnline()) return { error: { message: 'No connection to server' } };
    setLoading(true);
    setError(null);

    const { data, error: rpcError } = await supabase.rpc('join_household_by_invite', {
      code,
      member_name: memberName,
      member_type: memberType,
    });

    setLoading(false);
    if (rpcError) {
      setError(rpcError.message);
      return { error: rpcError };
    }
    return { data };
  }, []);

  const fetchMembership = useCallback(async () => {
    if (!isOnline()) return { data: null };

    const { data, error: rpcError } = await supabase.rpc('get_my_membership');

    if (rpcError) return { error: rpcError };
    return { data: data || null };
  }, []);

  return { createHousehold, joinHousehold, fetchMembership, loading, error };
}

export function useHouseholdAdmin() {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const updateHouseholdName = useCallback(async (name) => {
    if (!isOnline()) return { error: { message: 'No connection to server' } };
    setLoading(true);
    setError(null);

    const { error: rpcError } = await supabase.rpc('update_household_name', {
      p_name: name,
    });

    setLoading(false);
    if (rpcError) {
      setError(rpcError.message);
      return { error: rpcError };
    }
    return { data: true };
  }, []);

  return { updateHouseholdName, loading, error };
}
